<template>
  <BasicModal
    :title="title"
    :isShowModal="isShowModal"
    :canCancel="true"
    @cancel="cancel">
    <div class="card-body">
      <!-- アクション -->
      <div class="modal-top-area">
        <div class="action-box">
          <button class="button"
            :class="{'is-primary': autoScoutSettingSync.isScout}"
            @click="autoScoutSettingSync.isScout = !autoScoutSettingSync.isScout">
            自動スカウト
            {{autoScoutSettingSync.isScout ? 'ON' : 'OFF'}}
          </button>
          <p>現在自動スカウト設定は{{autoScoutSettingSync.isScout ? 'ON' : 'OFF'}}です</p>
        </div>
        <div>
          <div class="question-button-wrapper">
            <QuestionButton @click.native="isHowToUseAutoScout = true" />
          </div>
        </div>
      </div>
      <!-- 設定一覧 -->
      <div class="setting-card">
        <h2>スカウト種類</h2>
        <div class="input-box">
          <select class="select" v-model="autoScoutSettingSync.scout">
            <option v-for="(s, i) in scouts" :key="i + '-scout'" :value="s">
              {{s.name}}
            </option>
          </select>
        </div>
      </div>
      <div class="setting-card">
        <h2>スカウト先URL</h2>
        <div class="input-box">
          <input v-model="autoScoutSettingSync.scoutPageUrl" class="input is-small" type="text">
        </div>
      </div>
      <div class="setting-card">
        <h2>セグメント</h2>
        <div class="input-box">
          <select class="select" v-model="autoScoutSettingSync.segment">
            <option v-for="(s, i) in segments" :key="i + '-segments'" :value="i">
              {{s}}
            </option>
          </select>
        </div>
      </div>
      <div class="setting-card">
        <h2>訪問回数</h2>
        <div class="input-box">
          <b-numberinput
            v-model="autoScoutSettingSync.visitedCount"
            size="is-small"
            min="1" max="50" step="1"
            :editable="false">
          </b-numberinput>
          <p>回以上</p>
        </div>
      </div>
      <div class="setting-card">
        <h2>滞在時間</h2>
        <div class="input-box">
          <b-numberinput
            v-model="autoScoutSettingSync.spendTime"
            size="is-small"
            min="0" max="3600" step="15"
            :editable="false">
          </b-numberinput>
          <p>秒以上</p>
        </div>
      </div>
      <div class="setting-card">
        <h2>ロボとの会話</h2>
        <div class="input-box">
          <select class="select" v-model="autoScoutSettingSync.isConv">
            <option v-for="(f, i) in [false, true]" :key="i + '-cov'" :value="f">
              {{f ? '会話あり' : '会話なし'}}
            </option>
          </select>
        </div>
      </div>
    </div>
    <!-- フッターアクション -->
    <div class="footer-box">
      <button class="button" @click="cancel">キャンセル</button>
      <button class="button is-primary" @click="setAutoScout(autoScoutSettingSync)">保存する</button>
    </div>
    <!-- 使い方説明モーダル -->
    <ModalHowToUseAutoScout
      :isShowModal="isHowToUseAutoScout"
      @cancel="cancelHowToUseAutoScout"
    />
  </BasicModal>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import ModalHowToUseAutoScout from '@/components/organisms/modals/ModalHowToUseAutoScout'
import QuestionButton from '@/components/atoms/buttons/QuestionButton'

export default {
  name: 'ModalAutoScout',
  componentName: 'ModalAutoScout',
  components: {
    BasicModal,
    ModalHowToUseAutoScout,
    QuestionButton,
  },
  props: {
    scouts: {
      type: Array,
      require: false
    },
    isShowModal: {
      type: Boolean,
      require: false
    }
  },
  data () {
    return {
      title: '自動スカウト設定',
      segments: [
        '-',
        '有望フラグ',
        '自社動機付けチャンスフラグ'
      ],
      autoScoutSettingSync: {
        isScout: false,
        segment: 0,
        visitedCount: 1,
        spendTime: 30,
        isConv: false,
        scoutPageUrl: '',
      },
      isHowToUseAutoScout: false,
    }
  },
  methods: {
    cancel () {
      this.autoScoutSettingSync = {
        scout: null,
        isScout: false,
        segment: 0,
        visitedCount: 1,
        spendTime: 30,
        isConv: false,
        scoutPageUrl: '',
      }
      this.$emit('cancel', false)
    },
    setAutoScout (data) {
      if (!this.autoScoutSettingSync.scout) {
        alert('スカウト種類を設定してください')
        return
      }
      this.$emit('setAutoScout', data)
    },
    cancelHowToUseAutoScout () {
      this.isHowToUseAutoScout = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.card-body {
  padding: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
}
.setting-card {
  height: 120px;
  width: 280px;
  border-radius: 8px;
  border: solid thin #ccc;
  margin: 8px 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h2 {
    font-weight: 600;
    color: #C82E42;
    margin-bottom: 8px;
  }
  .input-box {
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      margin-left: 8px;
    }
    select {
      max-width: 200px;
    }
  }
}
.action-box {
  width: calc(100% - 32px);
  height: 48px;
  display: flex;
  align-items: center;
  margin-left: 16px;
  p {
    margin-left: 16px;
  }
}
.footer-box {
  width: 100%;
  height: 64px;
  border-top: solid thin #ccc;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  button {
    width: 47%;
  }
}
.modal-top-area {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.question-button-wrapper {
  margin-right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/DirectTalk/ModalAutoScout.vue